import {isRTL} from '../../../../../Localization';

const he = {
    saved: 'All changes were saved',
    updating: 'Saving...'
};

const en = {
    saved: 'כל השינויים נשמרו בהצלחה',
    updating: 'Saving...'
};

export const texts = isRTL() ? en : he;
